import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { Crumbs } from "@/components/content/ContentBits";
import { TOOLS } from "@/pages/ToolPage";
import { HUB_FAQ, HUB_FIT, HUB_INTRO, HUB_TOOLS } from "@/content/toolsHub";

const H2 = ({ children }) => <h2 className="mt-14 font-display text-2xl leading-snug text-foreground sm:text-3xl">{children}</h2>;

const ToolSections = () => TOOLS.map((t) => (
  <section key={t.slug} data-testid={`tools-section-${t.slug}`}>
    <H2>{HUB_TOOLS[t.slug].h2}</H2>
    <p className="mt-4">{HUB_TOOLS[t.slug].text}</p>
    <Link to={`/tools/${t.slug}`} data-testid={`tools-section-link-${t.slug}`} className="mt-4 inline-flex min-h-[44px] items-center text-[#5EE6D0] underline underline-offset-4">
      {HUB_TOOLS[t.slug].cta} →
    </Link>
  </section>
));

export default function ToolsHub() {
  return (
    <PublicLayout>
      <div data-testid="tools-hub" className="mx-auto max-w-7xl px-5 py-10 sm:px-8 sm:py-14">
        <Crumbs testid="tools-breadcrumbs" items={[["Home", "/"], ["Free tools"]]} />
        <h1 data-testid="tools-h1" className="max-w-3xl font-display text-4xl leading-[1.05] sm:text-5xl lg:text-6xl">Free Etsy SEO tools</h1>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-muted-foreground">
          Three free tools for Etsy sellers, no sign-up and no email: draft 13 tags, write clear titles, and score a listing against Etsy's rules.
          The generators give AI suggestions for you to check against your own research. The checker is rule-based and unlimited.
        </p>
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {TOOLS.map((t, i) => (
            <Link key={t.slug} to={`/tools/${t.slug}`} data-testid={`tools-card-${t.slug}`}
              className="group flex flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-7 transition-[background-color,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-[#E9C98B]/35 hover:bg-white/[0.05]">
              <span className="font-mono text-xs text-[#F3DDAE]/80">0{i + 1}</span>
              <span className="mt-4 font-display text-2xl text-foreground">{t.name}</span>
              <span className="mt-3 text-sm leading-relaxed text-muted-foreground">{t.blurb}</span>
              <span className="mt-auto pt-6 text-sm text-[#5EE6D0] group-hover:underline underline-offset-4">Open the tool →</span>
            </Link>
          ))}
        </div>
        <div data-testid="tools-hub-copy" className="mt-16 max-w-3xl text-[17px] leading-[1.75] text-muted-foreground">
          {HUB_INTRO.map((p) => <p key={p.slice(0, 24)} className="mt-5 first:mt-0">{p}</p>)}
          <ToolSections />
          <section data-testid="tools-fit">
            <H2>How these free Etsy SEO tools fit together</H2>
            <p className="mt-4">{HUB_FIT}</p>
          </section>
          <section data-testid="tools-faq">
            <H2>FAQ</H2>
            {HUB_FAQ.map(([q, ans]) => <div key={q} className="mt-6"><h3 className="font-semibold text-foreground">{q}</h3><p className="mt-2">{ans}</p></div>)}
          </section>
        </div>
        <p className="mt-12 max-w-2xl text-sm text-muted-foreground">
          Want to understand the rules behind them? Start with <Link to="/blog" className="text-[#5EE6D0] underline underline-offset-4">our Etsy SEO guides</Link> or
          browse <Link to="/etsy-tags" className="text-[#5EE6D0] underline underline-offset-4">Etsy tags by product</Link>.
        </p>
      </div>
    </PublicLayout>
  );
}
